<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">票据列表</span></div>
    <div class="margin-right-left margin-top">
      <account-date-choose v-model="accountDate"/>
      <div class="float-right">
        <Button color="primary" icon="h-icon-plus" @click="addBill">新增票据</Button>
        <Button :loading="loading" @click="exportData">导出</Button>
        <Button v-if="User.role!=='View'" color="red" @click="batchDelete">删除</Button>
      </div>
    </div>
    <div class="h-panel-body">
      <div class="modern-table">
        <div class="table-header">
          <div class="header-cell checkbox-cell">
            <input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll">
          </div>
          <div class="header-cell bill-no-cell">票据编号</div>
          <div class="header-cell date-cell">开票日期</div>
          <div class="header-cell type-cell">类型</div>
          <div class="header-cell amount-cell">金额</div>
          <div class="header-cell party-cell">开票方</div>
          <div class="header-cell party-cell">收票方</div>
          <div class="header-cell summary-cell">摘要</div>
          <div class="header-cell actions-cell">操作</div>
        </div>

        <div v-if="!datas.length" class="empty-state">
          <div class="empty-icon">📄</div>
          <div class="empty-text">暂无票据数据</div>
          <div class="empty-hint">点击右上角"新增"按钮添加第一张票据</div>
        </div>
        <div v-for="data in datas" :key="data.id" class="table-row">
          <div class="row-cell checkbox-cell">
            <input v-model="data._checked" type="checkbox">
          </div>
          <div class="row-cell bill-no-cell">
            <div class="cell-content">
              <div class="primary-text">{{ data.billNo }}</div>
              <div class="secondary-text" v-if="data.invoiceNumber">发票号: {{ data.invoiceNumber }}</div>
            </div>
          </div>
          <div class="row-cell date-cell">
            <div class="cell-content">
              <div class="primary-text">{{ data.billDate | date }}</div>
            </div>
          </div>
          <div class="row-cell type-cell">
            <div class="cell-content">
              <div class="type-badge" :class="getTypeBadgeClass(data.type)">
                {{ data.type }}
              </div>
            </div>
          </div>
          <div class="row-cell amount-cell">
            <div class="cell-content">
              <div class="amount-text">{{ data.amount | currency }}</div>
              <div class="secondary-text" v-if="data.taxRate">税率: {{ data.taxRate }}%</div>
            </div>
          </div>
          <div class="row-cell party-cell">
            <div class="cell-content">
              <div class="primary-text" :title="data.issuer">{{ data.issuer || '-' }}</div>
            </div>
          </div>
          <div class="row-cell party-cell">
            <div class="cell-content">
              <div class="primary-text" :title="data.recipient">{{ data.recipient || '-' }}</div>
            </div>
          </div>
          <div class="row-cell summary-cell">
            <div class="cell-content">
              <div class="primary-text" :title="data.summary">{{ data.summary || '-' }}</div>
            </div>
          </div>
          <div class="row-cell actions-cell">
            <div class="action-buttons">
              <router-link class="action-btn view-btn" :to="{name:'BillForm',params:{billId:data.id}}">
                <i class="icon-view">👁</i>查看
              </router-link>
              <router-link v-if="User.role!=='View'" class="action-btn edit-btn" :to="{name:'BillForm',params:{billId:data.id}}">
                <i class="icon-edit">✏️</i>修改
              </router-link>
              <button v-if="User.role!=='View'" class="action-btn delete-btn" @click="remove(data)">
                <i>🗑</i>删除
              </button>
            </div>
          </div>
        </div>
      </div>
      <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
    </div>
  </app-content>
</template>

<script>
  import moment from 'moment'
  import {mapState} from 'vuex'

  export default {
    name: "BillList",
    data() {
      return {
        datas: [],
        accountDate: null,
        pagination: {
          page: 1,
          total: 0
        },
        loading: false,
        checkAll: false
      };
    },
    watch: {
      checkAll(nval) {
        let data = Array.from(this.datas);
        data.forEach(val => val._checked = nval);
        this.datas = data;
      },
      accountDate() {
        this.pagination.page = 1;
        this.loadList();
      }
    },
    computed: {
      ...mapState(['User', 'currentAccountSets']),
      date() {
        return moment(this.accountDate);
      }
    },
    methods: {
      currentChange() {
        this.loadList();
      },
      addBill() {
        this.$router.push({name: 'BillForm'});
      },
      exportData() {
        const checkedRows = this.datas.filter(item => item._checked);
        if (!checkedRows.length) {
          this.$Message("请先勾选需要导出的发票");
          return;
        }
        const ids = checkedRows.map(item => item.id).join(',');
        this.loading = true;
        this.$api.bill.exportDeduction(ids).then(() => {
          this.$Message.success("导出任务已开始，请在浏览器查看下载的Excel");
        }).finally(() => {
          this.loading = false;
        });
      },
      loadList() {
        this.loading = true;
        this.$api.bill.list({
          bill_year: this.date.year(), 
          bill_month: this.date.month() + 1, 
          page: this.pagination.page
        }).then(({data}) => {
          this.datas = data.records;
          this.pagination = {
            page: data.current,
            size: data.size,
            total: data.total
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      remove(data) {
        this.$Confirm("确认删除?").then(() => {
          this.loading = true;
          this.$api.bill.delete(data.id).then(() => {
            this.loadList();
            this.$Message("删除成功");
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      batchDelete() {
        let checked = this.datas.filter(value => value._checked);
        if (checked.length === 0) {
          this.$Message("请选择要删除的票据");
          return;
        }
        this.$Confirm(`确认删除选中的 ${checked.length} 条票据?`).then(() => {
          this.loading = true;
          let ids = checked.map(value => value.id);
          this.$api.bill.batchDelete(ids).then(() => {
            this.loadList();
            this.$Message("批量删除成功");
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      // 状态相关方法已隐藏，但保留以备将来扩展
      // getStatusClass(status) {
      //   switch(status) {
      //     case '未使用':
      //       return 'status-unused';
      //     case '已使用':
      //       return 'status-used';
      //     case '已作废':
      //       return 'status-invalid';
      //     default:
      //       return '';
      //   }
      // }

      // 获取票据类型徽章样式
      getTypeBadgeClass(type) {
        switch(type) {
          case '电子发票(专用发票)':
          case '增值税专用发票':
            return 'type-special';
          case '电子发票(普通发票)':
          case '增值税普通发票':
            return 'type-normal';
          case '收据':
            return 'type-receipt';
          case '发票':
            return 'type-invoice';
          default:
            return 'type-default';
        }
      }
    },
    mounted() {
      // 初始化日期为当前账套日期
      this.accountDate = this.currentAccountSets.currentAccountDate;
      this.loadList();
    }
  };
</script>

<style lang="less" scoped>
  .modern-table {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 20px;
  }

  /* Define the grid template variable for reuse */
  @table-columns: 50px 140px 100px 160px 140px minmax(120px, 1fr) minmax(120px, 1fr) minmax(150px, 2fr) 160px;

  .table-header {
    display: grid;
    grid-template-columns: @table-columns;
    background: #3788ee;
    color: white;
    font-weight: 600;
    font-size: 14px;
    padding: 0;
  }

  .header-cell {
    padding: 16px 12px;
    display: flex;
    align-items: center;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden; /* Prevent overflow */

    &:last-child {
      border-right: none;
    }
  }

  .table-row {
    display: grid;
    grid-template-columns: @table-columns;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f8f9ff;
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      z-index: 1; /* Ensure shadow is visible */
      position: relative;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .row-cell {
    padding: 16px 12px;
    display: flex;
    align-items: center;
    border-right: 1px solid #f0f0f0;
    overflow: hidden; /* Prevent overflow */

    &:last-child {
      border-right: none;
    }
  }

  .cell-content {
    width: 100%;
    min-height: 20px;
    overflow: hidden;
  }

  .primary-text {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    line-height: 1.4;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .secondary-text {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
    line-height: 1.3;
  }

  .amount-text {
    font-size: 16px;
    font-weight: 600;
    color: #1890ff;
    font-family: 'Courier New', monospace;
  }

  // Specific cell styles (mostly for internal alignment now)
  .checkbox-cell {
    justify-content: center;
  }

  // Type badge styles
  .type-badge {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    text-align: center;
    white-space: normal;
    line-height: 1.2;
  }

  .type-special {
    background: linear-gradient(135deg, #ff6b6b, #ee5a24);
    color: white;
  }

  .type-normal {
    background: linear-gradient(135deg, #4ecdc4, #44a08d);
    color: white;
  }

  .type-receipt {
    background: linear-gradient(135deg, #a8edea, #fed6e3);
    color: #333;
  }

  .type-invoice {
    background: linear-gradient(135deg, #ffecd2, #fcb69f);
    color: #333;
  }

  .type-default {
    background: linear-gradient(135deg, #e0e0e0, #bdbdbd);
    color: #333;
  }

  // Action buttons
  .action-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    text-decoration: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
  }

  .view-btn {
    background: linear-gradient(135deg, #74b9ff, #0984e3);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #0984e3, #74b9ff);
    }
  }

  .edit-btn {
    background: linear-gradient(135deg, #00b894, #00a085);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #00a085, #00b894);
    }
  }

  .delete-btn {
    background: linear-gradient(135deg, #fd79a8, #e84393);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #e84393, #fd79a8);
    }
  }

  // Empty state
  .empty-state {
    text-align: center;
    padding: 60px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.6;
  }

  .empty-text {
    font-size: 18px;
    color: #666;
    margin-bottom: 8px;
    font-weight: 500;
  }

  .empty-hint {
    font-size: 14px;
    color: #999;
  }

  // Responsive design
  @media (max-width: 1200px) {
    /* Adjust grid for medium screens if needed, or rely on minmax */
    .table-header, .table-row {
       /* Slightly tighter columns */
       grid-template-columns: 50px 120px 100px 100px 120px 1fr 1fr 1.5fr 140px;
    }
  }

  @media (max-width: 768px) {
    .table-header {
      display: none; /* Hide header on mobile */
    }

    .table-row {
      display: flex;
      flex-direction: column;
      height: auto;
    }

    .row-cell {
      border-right: none;
      border-bottom: 1px solid #f0f0f0;
      padding: 12px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &::before {
        content: attr(data-label); /* Requires data-label attr in HTML, but we don't have it yet. */
        /* Fallback or simple mobile view */
        font-weight: 600;
        color: #666;
        flex: 0 0 80px;
      }
    }
  }
</style>
